import { v4 as uuidv4 } from 'uuid';

// HTTP LAN origins lack randomUUID, although getRandomValues is available.
// Run before App and its dependencies (including react-scan) are evaluated.
const browserCrypto = globalThis.crypto;
if (
  browserCrypto &&
  typeof browserCrypto.randomUUID !== 'function' &&
  typeof browserCrypto.getRandomValues === 'function'
) {
  // Options force uuid's getRandomValues path, avoiding delegation back to
  // this polyfill if another copy of uuid captures it as the native method.
  browserCrypto.randomUUID = () => uuidv4({});
}
